import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../../strings";
import { translate } from "../../../../translate";
import AnimatedModal from "../../../AnimatedModal";
import { AppButton } from "../../AppButton";
import { AppOverlay } from "../../AppOverlay";
import CaregiverRankHeading from "./CaregiverRankHeading";

type Props = {
  icon: React.ComponentPropsWithoutRef<typeof CaregiverRankHeading>["icon"];
  name: React.ComponentPropsWithoutRef<typeof CaregiverRankHeading>["name"];
  wage: React.ComponentPropsWithoutRef<typeof CaregiverRankHeading>["wage"];
  isOpen: boolean;
  onRequestClose: () => void;
};

export default function CareMomentRankPromotionModal(props: Props) {
  return (
    <AppOverlay>
      <AnimatedModal.Styled isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
        <AnimatedModal.AnimationWrapper offset={0}>
          <Image src="/assets/3d-render-hands-with-pink-heart-inside-fingers.png" alt="promotion" />
        </AnimatedModal.AnimationWrapper>
        <AnimatedModal.Headline>{translate(STRINGS.CONGRATULATIONS)}</AnimatedModal.Headline>
        <AnimatedModal.Message>{translate(STRINGS.YOU_JUST_GOT_PROMOTED_TO)}</AnimatedModal.Message>

        <CaregiverRankHeading icon={props.icon} name={props.name} wage={props.wage} />

        <AnimatedModal.Message>{translate(STRINGS.KEEP_UP_THE_GOOD_WORK)}</AnimatedModal.Message>
        <AnimatedModal.Actions>
          <AppButton size="large" onClick={props.onRequestClose}>
            {translate(STRINGS.SEE_YOUR_PROGRESS)}
          </AppButton>
        </AnimatedModal.Actions>
      </AnimatedModal.Styled>
    </AppOverlay>
  );
}

const Image = styled.img`
  max-height: 128px;
  max-width: 100%;
`;
